import { Auth } from 'aws-amplify'
export const getJWTToken = async () => {
    return (await Auth.currentSession()).getIdToken().getJwtToken()
}